import React, { useEffect, useState, useRef} from "react";
import './navbar.css'
import { useDispatch, useSelector  } from 'react-redux';
import { Link, useNavigate, NavLink } from 'react-router-dom';
import { DollarSign, PanelLeftClose, PanelRightClose, ChevronDown, User, LogOut } from 'lucide-react';

import { getAccountBalance } from '../../apis/Topup'
import { getUserDetails } from '../../apis/UserAPI';

import { toast } from 'sonner'

const Navbar = ({ toggleSideBar, hideSidebar, showSidebar, hidden }) => {

  const dispatch = useDispatch()
  let navigate = useNavigate()

  const selector = useSelector((state) => state.auth)
  const userDetails = JSON.parse(selector?.userInfo)
  const [accountBalance, setAccountBalance] = useState()
  // const [user, setUser] = useState();
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const profileRef = useRef(null);

  useEffect(() => {
    getAccountBalance(dispatch).then(resp => {
      if (resp?.data?.status === "success") { 
        setAccountBalance(resp?.data?.data)
      }
    })

    getUserDetails(dispatch).then(resp => {
      if (resp?.status === 200) { 
        // setUser(resp?.data?.data) 
      }
      else { toast.error("Unabled to fetch roles!", { theme: "colored" }) }
  })
  }, [dispatch])

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  }

  const logoutUser = () => {
    localStorage.clear()
    navigate('/auth/login')
  }

  return (
    <div className="navbar">

    <div className="medium-device flex">
      <PanelLeftClose className={`text-gray-600 h-6 w-6 mr-5 cursor-pointer ${!hidden ? 'block' : 'hidden'}`} onClick={hideSidebar} />
      <PanelRightClose className={`text-gray-600 h-7 w-7 mr-5 cursor-pointer ${hidden ? 'block' : 'hidden'}`} onClick={showSidebar}/>

      <div className="balance-section">
        <div className="flex items-center gap-2">
          <DollarSign className="h-7 w-7 bg-blue-100 text-blue-600 p-1 rounded rounded-[10px]" />
          <div className="">   
            <p id="credit-currency">Balance</p>
            <p id="credit-amount"> $ {accountBalance?.credits}</p>
          </div>
          <Link className='topup-btn' to='/app/topup'>Top up</Link>
        </div>
      </div>
    </div>  

     {/* user profile section */}
     <div className='sidebar-profile-section' ref={profileRef}>
          <div className='sidebar-profile-btn' onClick={toggleProfileMenu}>
            <div className="profile-avatar">
              <img 
                src={process.env.PUBLIC_URL + "/images/user.png"} 
                alt="user avatar" 
                className="profile-image"
              /> 
            </div>
            <div className="profile-details">
              <span className='profile-name'>
                {userDetails?.client?.name ? userDetails?.client?.name : "User Company"}
              </span>
              {/* <span className='profile-email'>{user?.username}</span> */}
            </div>
            <ChevronDown 
              className={`profile-chevron ${isProfileMenuOpen ? 'rotated' : ''}`} 
              size={16} 
            />
          </div>

          <div className={`sidebar-profile-links ${isProfileMenuOpen ? 'show' : ''}`}>
            <NavLink to='/app/profile' className='profile-link' onClick={() => setIsProfileMenuOpen(false)}>
              <User size={18} />
              <span>Profile</span>
            </NavLink>
            <button className='profile-link logout-btn' onClick={logoutUser}>
              <LogOut size={18} />
              <span>Logout</span>
            </button>
          </div>
      </div>

  </div>
  )
}

export default Navbar